import { createFileRoute } from "@tanstack/react-router";
import { CreditCard } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { PayLink } from "@/features/payments/modules/pay-link/pay-link";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/pay/$orderId/")({
  loader: () => ({ crumb: m.pay_link_title() }),
  component: PayPage,
});

function PayPage() {
  const { orderId } = Route.useParams();
  return (
    <PageShell icon={CreditCard} title={m.pay_link_title()}>
      <PayLink orderId={orderId} />
    </PageShell>
  );
}
